import firebase from "firebase/app";
import "firebase/storage";
import "firebase/database";

let config = {
  apiKey: "AIzaSyAQMlSm33dgfrqXTpkKe27E6TGhXbffutY",
  authDomain: "les-augis.firebaseapp.com",
  databaseURL: "https://les-augis.firebaseio.com",
  projectId: "les-augis",
  storageBucket: "les-augis.appspot.com",
  messagingSenderId: "19015953762",
  appId: "1:19015953762:web:f5c809446e22057411d03b",
  measurementId: "G-DFNF08CW65",
};
firebase.initializeApp(config);

/*let uiConfig = {
  signInSuccessUrl: "bijouterieherre.fr",
  signInOptions: [firebase.auth.GoogleAuthProvider.PROVIDER_ID],
  tosUrl: "bijouterieherre.fr",
  privacyPolicyUrl: function () {
    window.location.assign("bijouterieherre.fr");
  },
};
let ui = new firebaseui.auth.AuthUI(firebase.auth());*/

export default firebase;
